import React, { useEffect } from 'react';
import {
  useConsultation,
  ConsultationDetails,
  Consultations,
} from '../../hooks/useConsultation';
import { usePayment } from '../../hooks/usePayment';
import Consultation from './Consultation';
import LoadingSpinner from '../LoadingSpinner';
import { User } from '../../types/Auth';
import Section from '../Modular/Section';
import './Dashboard.css';
import Button from '../Button';

import { useAuth } from '../../contexts/AuthProvider/AuthProvider';
import Unit from '../Modular/Unit';
import Clients from './Clients';

interface DashboardProps {
  user: User;
}

const Dashboard = ({ user }: DashboardProps) => {
  const {
    fetchConsultation,
    fetchConsultationsByClient,
    consultation,
    consultations,
    loading,
  } = useConsultation();
  const { initiatePayment, checkoutReady, checkoutUrl } = usePayment();
  const { logout } = useAuth();

  const isPaid = consultation?.isPaid ?? false;

  useEffect(() => {
    const initPayment = async () => {
      let consultation: ConsultationDetails | null = null;
      let consultations: Consultations | null = null;

      if (user && !user.is_admin) {
        consultation = await fetchConsultation();
        // console.log('Fetched consultation:', consultation);
      }

      if (consultation && !consultation.isPaid) {
        console.log(consultation);
        await initiatePayment(
          consultation.consultation_id,
          consultation.chargeAmount,
        );
      }
    };

    initPayment();
  }, []);

  const proceedToCheckout = async () => {
    window.location.href = checkoutUrl;
  };

  return (
    <div className="consultation-container">
      {loading && <LoadingSpinner></LoadingSpinner>}
      <h3 className="user-details">{`Welcome ${user?.firstName} ${user?.lastName}`}</h3>
      {consultation && (
        <>
          <Consultation consultation={consultation}></Consultation>

          <Unit gap="xl">
            <div className="make-payment">
              {consultation && !isPaid && (
                <Button
                  variant="primary"
                  onClick={proceedToCheckout}
                  disabled={!checkoutReady}
                >
                  Make Payment
                </Button>
              )}
            </div>
            <div className="logout">
              <Button variant="outline" onClick={logout}>
                Log out
              </Button>
            </div>
          </Unit>
        </>
      )}
      {!loading && !consultation && !user.is_admin && (
        <>
          <p className="no-consultation">
            You have no active consultations at the moment.
          </p>

          <div className="logout">
            <Button variant="outline" onClick={logout}>
              Log out
            </Button>
          </div>
        </>
      )}
      {user.is_admin && <Clients adminUserId={user.user_id}></Clients>}
    </div>
  );
};

export default Dashboard;
